import React from 'react';
import { Check } from 'lucide-react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

const AuditStepper = ({ phases, session }) => {
  const lockedPhases = session?.locked_phases || {};

  return (
    <div className="w-full overflow-x-auto pb-2 mb-4 scrollbar-hide">
      <TabsList className="flex w-max min-w-full justify-start md:justify-center p-1 space-x-2 bg-slate-100/50 dark:bg-slate-800/50 h-auto" data-testid="phases-tabs">
        {Object.entries(phases).map(([k, v], index) => {
          const isLocked = lockedPhases[k];
          return (
            <TabsTrigger 
              key={k} 
              value={k} 
              data-testid={`tab-${k}`}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-md transition-all data-[state=active]:bg-white data-[state=active]:shadow-sm dark:data-[state=active]:bg-slate-950 data-[state=active]:text-blue-700 dark:data-[state=active]:text-blue-400"
            >
              <div className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium transition-colors ${
                isLocked 
                  ? 'bg-emerald-500 text-white dark:bg-emerald-600' 
                  : 'bg-slate-200 text-slate-600 dark:bg-slate-800 dark:text-slate-400 group-data-[state=active]:bg-blue-600 group-data-[state=active]:text-white dark:group-data-[state=active]:bg-blue-600'
              }`}>
                {isLocked ? <Check className="w-3.5 h-3.5" /> : (index + 1)}
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{v.split(" — ")[0]}</span>
            </TabsTrigger>
          );
        })}
      </TabsList>
    </div>
  );
};

export default AuditStepper;
